import { Box } from '@material-ui/core';

import { IberiaCardsCampaign } from '@/components/modules/Application/IberiaCards/_shared/types/IberiaCardsCampaign';
import { AviosTag } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/components/AviosTag';
import { IBERIA_CARDS_CAMPAIGNS } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/constants/IberiaCardsCampaigns';
import { SALE_POINTS } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/constants/SalePoints';
import { useStandsAgent } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/hooks/useStandsAgent';
import { CampaignGroupMap } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/maps/campaignGroup.map';
import { CampaignValidityMap } from '@/components/modules/Application/IberiaCards/modules/SalePointAndProduct/maps/campaignValidity.map';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { SelectOption } from '@/types/selectOption';

export const SalePointAndProductFields = () => {
  const { standsAgent } = useStandsAgent();

  const standsAgentSalePointOptions: SelectOption[] = SALE_POINTS.filter(({ id }) =>
    standsAgent?.salePointIds.includes(id),
  ).map((salePoint) => ({
    value: salePoint.id,
    display: salePoint.channelCode.toUpperCase(),
  }));

  const today = CampaignValidityMap.toIsoDate(new Date());
  const campaignOptions = CampaignGroupMap.sortByGroup(
    CampaignValidityMap.filterActive(IBERIA_CARDS_CAMPAIGNS, today),
  ).map(toCampaignOption);

  return (
    <FormGridContainer fieldVariant={FieldVariant.form} fullWidth>
      <SelectFormField
        name={'salePoint'}
        label={'MERCHANT_CHANNEL_AGENT_POS'}
        selectOptions={standsAgentSalePointOptions}
        fieldVariant={FieldVariant.form}
      />
      <SelectFormField
        name={'campaign'}
        label={'CARD_AND_CAMPAIGN'}
        selectOptions={campaignOptions}
        fieldVariant={FieldVariant.form}
      />
    </FormGridContainer>
  );
};

const toCampaignOption = (campaign: IberiaCardsCampaign): SelectOption => ({
  value: campaign.id,
  group: CampaignGroupMap.toTextId(campaign.group),
  // The label is left unwrapped so it inherits the same type styles as a plain-string
  // option (see common.styles.ts), keeping it consistent with the Punto de venta field.
  display: (
    <FlexRow
      display={'inline-flex'}
      justifyContent={'flex-start'}
      flexWrap={'wrap'}
      gridGap={'4px 12px'}
    >
      <Box component={'span'} whiteSpace={'normal'}>
        {`IBERIA ${campaign.product} - ${campaign.description}`.toUpperCase()}
      </Box>
      <AviosTag avios={campaign.avios} />
    </FlexRow>
  ),
});
